import IconAlert from '@/components/assets/icon_alert.svg'
import DefaultAlertDialog from '@/components/DefaultAlertDialog'
import { useUAContext } from '@/context/UAContext'
import { useTranslations } from 'next-intl'

type VramAlertModalProps = {
  onCancel?: () => void
  onAction?: () => void
}

export default function VramAlertModal({ onCancel, onAction }: VramAlertModalProps) {
  const t = useTranslations()
  const { deviceType } = useUAContext()
  const isDesktop = deviceType === 'desktop'
  return (
    <DefaultAlertDialog
      open={true}
      titleIcon={<IconAlert className="h-[40px] w-[40px] fill-[#F8E64A]" />}
      title={t(
        isDesktop
          ? 'loading-screen.performance-alert-pc.title'
          : 'loading-screen.performance-alert.title',
      )}
      description={t(
        isDesktop
          ? 'loading-screen.performance-alert-pc.description'
          : 'loading-screen.performance-alert.description',
      )}
      cancelText={t('loading-screen.performance-alert.continue')}
      actionText={t('loading-screen.performance-alert.go-trailer')}
      onCancel={onCancel}
      onAction={onAction}
      allowOutsideInteraction={true}
    />
  )
}
